import type Player from "@/components/Player/Player.vue";

export type PlayerRef = InstanceType<typeof Player>;

export interface ExposeInterface {
    clickBtnsReplay(): void;
    toggleShowControls(): void;
    onHide(): void;
    goNextEpisode(): Promise<void>;
    goPrevEpisode(): Promise<void>;
    onRewind(): void;
    onPlayPressed(): void;
    onPausePressed(): void;
    onFastForward(): void;
    onLeftPressed(): void;
    onRightPressed(): void;
    onNextChannelPressed(): void;
    onPrevChannelPressed(): void;
    confirmStop(): void;
    onPlay(): void;
};

export interface IVideoPlayer {
    getCurrentTime(): number;
    setCurrentTime(time: number): void;
    pause(): void;
    resume(): Promise<void> | undefined;
    restart(params?: VideoPlayParams): void;
    dispose(): Promise<void>;
    isPaused(): boolean;
};

export type VideoPlayParams = {
    mediaSource: string;
    token: string | null;
};
export class VideoPlayerEvent {
    constructor(
        public eventName: string,
        public player: IVideoPlayer,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public nativePlayer: any, // we can't fix the "any" errors until the Shaka player gets TypeScript support
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public nativeEvent: any) { // we can't fix the "any" errors until the Shaka player gets TypeScript support
    }
}
